import React from 'react';
import { PropTypes } from 'prop-types';

const TitleH2 = ({ text, height }) => <h2 className={`${height} text-28 font-americaBlack sm:text-20 md:text-18 lg:text-26 capitalize`}>{text}</h2>;

TitleH2.propTypes = {
  text: PropTypes.string,
  height: PropTypes.string,
};

TitleH2.defaultProps = {
  text: '',
  height: '',
};

export default TitleH2;
